import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/footer";
import PageSectionsRenderer from "../../components/common/PageSectionsRenderer";

const PrivacyPolicy = () => {
  return (
    <div className="bg-slate-50 min-h-screen">
      <Navbar />

      {/* Hero Section */}
      <section className="bg-blue-900 text-white py-20 px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4">Privacy Policy</h1>
          <p className="text-xl opacity-90">
            How we protect and handle your personal information.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="prose max-w-none text-slate-600">
              <p className="text-sm text-slate-500 mb-8">Last updated: February 18, 2026</p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Information We Collect</h2>
              <p className="mb-6">
                We collect information you provide directly to us, such as when you register for events,
                create an account, or contact us for support. This may include your name, email address,
                phone number, and other personal details necessary for participation in our programs.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">How We Use Your Information</h2>
              <p className="mb-6">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li>Provide and maintain our services</li>
                <li>Process event registrations and manage competitions</li>
                <li>Communicate with you about events and updates</li>
                <li>Ensure compliance with sports regulations and safety standards</li>
                <li>Improve our services and develop new programs</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Information Sharing</h2>
              <p className="mb-6">
                We do not sell, trade, or otherwise transfer your personal information to third parties
                without your consent, except as described in this policy. We may share information with
                event sponsors, government authorities, or other organizations involved in Para sports
                development as necessary for the proper functioning of our programs.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Data Security</h2>
              <p className="mb-6">
                We implement appropriate security measures to protect your personal information against
                unauthorized access, alteration, disclosure, or destruction. However, no method of
                transmission over the internet is 100% secure.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Your Rights</h2>
              <p className="mb-6">
                You have the right to access, update, or delete your personal information. You may also
                opt out of receiving promotional communications from us.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Contact Us</h2>
              <p className="mb-6">
                If you have any questions about this Privacy Policy, please contact us at:
              </p>
              <div className="bg-slate-50 p-4 rounded-lg">
                <p><strong>Email:</strong> privacy@parasportsap.org</p>
                <p><strong>Phone:</strong> +91-XXXXXXXXXX</p>
                <p><strong>Address:</strong> Para Sports Association of Andhra Pradesh</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PageSectionsRenderer pageKey="privacy_policy" className="pt-0" />

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
